import { GetStaticProps } from "next"
import contentful from "src/util/contentful"
import ContentfulDocument from "src/common/ContentfulDocument"

function Terms({ document }) {
  return (
    <ContentfulDocument
      document={document}
      title='Terms of service'
    />
  )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const entry = await contentful.getEntry<any>('483O5b1SOAQcCl74P7PtAx')

  return {
    props: {
      document: entry.fields.body || {},
    },
  }
}

export default Terms
